import { Tabs, type TabsProps } from "antd";
import { clsx } from "clsx";

import styles from "./RVTabs.module.scss";

export type RVTabsProps = TabsProps & {
    /** Additional className applied to the root Tabs element. */
    className?: string;
};

/**
 * RVTabs - Regal styled wrapper around Ant Design's Tabs component.
 *
 * Replaces the default purple ink-bar selection style with a segmented control:
 * the nav bar sits on a light grey (gray-1) background, tabs are separated by
 * gray-2 dividers, and the active tab is filled white.
 *
 * Use `RVTabs.TabPane` for panels, exactly like `Tabs.TabPane`.
 *
 * @example
 * <RVTabs defaultActiveKey="prompt">
 *     <RVTabs.TabPane tab="Agent Prompt" key="prompt">...</RVTabs.TabPane>
 *     <RVTabs.TabPane tab="AI Analysis" key="analysis">...</RVTabs.TabPane>
 * </RVTabs>
 */
function RVTabsBase({ className, children, ...rest }: RVTabsProps): JSX.Element {
    return (
        <Tabs className={clsx(styles.RVTabs, className)} {...rest}>
            {children}
        </Tabs>
    );
}

export const RVTabs = Object.assign(RVTabsBase, { TabPane: Tabs.TabPane });
